import { useDispatch, useSelector } from 'react-redux'
import Page from '../../common/Page'
import PageCard from '../../common/PageCard'
import Actions from '../../../actions'
import { routes } from '../../../consts'
import $t from '../../../i18n'
import Card from '../../common/Card'
import mvpLogo from '../../../resources/mvp.png'
import { useState } from 'react'
import ActionButton from '../../common/ActionButton'
import {
  getMvpDate,
  getNumberTasksCompletedInPromoPeriod,
  isTaskCompleted,
  getNumberTasksCompleted,
  isPatientMvp,
  getPromoExpireDate,
  getDaysLeftUntilPromoExpire,
  checkIfNeedGiftCardMsg,
} from '../../../utils/onBoardingUtils'
import {
  COMPLETED_HEALTH_HISTORY,
  ON_BOARDING_COMPLETE_TASK_REWARD,
  TASKS_REQUIRED_TO_MVP,
  DOWNLOAD_APP,
} from '../../../consts/OnBoardingConsts'
import RiskAssessmentCompletedDialog from '../dialogs/RiskAssessmentCompletedDialog/RiskAssessmentCompletedDialog'
import AppDownloadConfirmationDialog from '../dialogs/AppDownloadConfirmationDialog'
import config from '../../../config.json'
import { isMobileWeb } from '../../../utils/detectMobileWeb'

import './MvpStatus.css'

const MvpStatus = () => {
  const dispatch = useDispatch()
  const now = new Date()
  const userDetails = useSelector(state => state.profile?.userDetails)
  const patientTasks = userDetails?.hmo_data?.on_boarding_tasks
  const enrollmentDate = userDetails?.hmo_data?.enrollment_date

  const promoPeriodDateExpire = getPromoExpireDate(enrollmentDate)
  const daysLeft = getDaysLeftUntilPromoExpire(promoPeriodDateExpire)

  // get the number of completed tasks in the promo period
  const numberOfCompletedTasksInPromoPeriod =
    getNumberTasksCompletedInPromoPeriod(patientTasks, promoPeriodDateExpire)

  // get the number of completed tasks(both in promo period and after promo period)
  const numberOfCompletedTasks = getNumberTasksCompleted(patientTasks)

  // check if the user need to get gift card message
  const isNeedGiftCardMsg = checkIfNeedGiftCardMsg(
    userDetails,
    numberOfCompletedTasksInPromoPeriod
  )

  const isDownloadApp = isTaskCompleted(patientTasks, DOWNLOAD_APP.name)
  const isCompleteHealthHistoryForm = isTaskCompleted(
    patientTasks,
    COMPLETED_HEALTH_HISTORY.name
  )

  const [expandMvpBenefit, setExpandMvpBenefit] = useState(false)

  const sendLinkToMobile = () => {
    if (isMobileWeb()) {
      window.open(config.downloadAppForMobile, '_blank')
    } else {
      dispatch(Actions.createAction(Actions.SHOW_APP_DOWNLOAD_LINK_POP_UP))
    }
    setTimeout(() => {
      dispatch(Actions.createAction(Actions.ENABLE_DOWNLOAD_LINK_BUTTON))
    }, 10000)
  }

  const onBoardingActions = [
    {
      title: $t(DOWNLOAD_APP.text),
      icon: isDownloadApp ? 'check' : 'check-circle-emply',
      iconSize: 20,
      displayArrow: false,
      className: isDownloadApp
        ? 'onboarding-action trackable checked'
        : 'onboarding-action trackable',
      onPress: () => {
        if (!isDownloadApp) {
          sendLinkToMobile()
        }
      },
    },
    {
      title: $t(COMPLETED_HEALTH_HISTORY.text),
      onPress: () => {
        if (!isCompleteHealthHistoryForm) {
          dispatch(Actions.createAction(Actions.RISK_ASSESMENT_BOT_STARTED))
          dispatch(
            Actions.createAction(
              Actions.NAVIGATED_TO,
              routes.RISK_ASSESSMENT_BOT
            )
          )
        }
      },
      displayArrow: !isCompleteHealthHistoryForm,
      icon: isCompleteHealthHistoryForm ? 'check' : 'check-circle-emply',
      iconSize: 20,
      className: isCompleteHealthHistoryForm
        ? 'onboarding-action trackable checked'
        : 'onboarding-action trackable',
    },
  ]

  const isMvp = isPatientMvp(userDetails)
  const mvpDate = isMvp ? getMvpDate(userDetails) : null

  return (
    <PageCard
      enableBack={true}
      onBack={() =>
        dispatch(
          Actions.createAction(
            Actions.NAVIGATED_TO,
            routes.PROFILE_ROUTE.PROFILE
          )
        )
      }
    >
      <Page className="mvp-status-page" title={$t('pages.mvpStatus.title')}>
        <Card className="info-card">
          <div className="info-section">
            <img src={mvpLogo} alt=""></img>
            <div className="info-section-title">
              {isMvp
                ? $t('pages.mvpStatus.titleMvp', {
                    date: mvpDate,
                  })
                : $t('pages.mvpStatus.titleNonMvp')}
              <span
                className="title-benefit semi-bold"
                onClick={() => setExpandMvpBenefit(!expandMvpBenefit)}
              >
                {expandMvpBenefit
                  ? $t('pages.mvpStatus.hideBenefit')
                  : $t('pages.mvpStatus.seeBenefit')}
              </span>
            </div>
          </div>
          {expandMvpBenefit && (
            <div className="additional-info">
              {$t('pages.mvpStatus.mvpBenefit1')}
              <br />
              <div className="check-back semi-bold">
                {$t('pages.mvpStatus.checkBack')}
              </div>
            </div>
          )}
        </Card>
        <div className="scroll streach">
          <div className="headline">
            {isMvp
              ? $t('pages.mvpStatus.mvpAchieved')
              : promoPeriodDateExpire >= now
              ? $t('pages.mvpStatus.daysToAchieved', {
                  days: daysLeft,
                })
              : $t('pages.mvpStatus.mvpAvailable')}
          </div>
          {promoPeriodDateExpire >= now && (
            <div className="status-reward">
              <span>
                {$t('pages.mvpStatus.rewardLevel', {
                  amount:
                    numberOfCompletedTasksInPromoPeriod *
                    ON_BOARDING_COMPLETE_TASK_REWARD,
                })}
              </span>
            </div>
          )}
          {isNeedGiftCardMsg && (
            <div className="reward-msg">
              <div className="congratulations semi-bold">
                {$t('pages.mvpStatus.congratulations')}{' '}
              </div>
              <div className="reward-on-email">
                {$t('pages.mvpStatus.rewardOnEmail', {
                  amount:
                    numberOfCompletedTasksInPromoPeriod *
                    ON_BOARDING_COMPLETE_TASK_REWARD,
                })}
                {userDetails?.username}
              </div>
            </div>
          )}
          {promoPeriodDateExpire < now &&
            numberOfCompletedTasks === TASKS_REQUIRED_TO_MVP && (
              <div className="reward-msg">
                {$t('pages.mvpStatus.completedTasks')}{' '}
              </div>
            )}
          {promoPeriodDateExpire < now &&
            numberOfCompletedTasks < TASKS_REQUIRED_TO_MVP && (
              <div className="reward-msg">
                {$t('pages.mvpStatus.taskRemain', {
                  count: TASKS_REQUIRED_TO_MVP - numberOfCompletedTasks,
                })}{' '}
              </div>
            )}
          <Card className="card-tasks">
            {onBoardingActions?.map((action, i) => (
              <ActionButton
                key={i}
                label={action?.title}
                iconName={action?.icon}
                size={action?.iconSize}
                className={action?.className}
                onPress={action?.onPress}
                displayArrow={!!action?.displayArrow}
                loading={action?.loading}
              />
            ))}
          </Card>
        </div>
        <RiskAssessmentCompletedDialog />
        <AppDownloadConfirmationDialog />
      </Page>
    </PageCard>
  )
}
export default MvpStatus
